import { Fill, Stroke, Style, Text } from 'ol/style';
import CircleStyle from 'ol/style/Circle';

export function achorLineStyle(isAccident: boolean) {
  return new Style({
    stroke: new Stroke({ color: isAccident ? '#ffd27f' : '#437c8d', width: 2 }),
  });
}

export function achorLineLabelStyle(name?: string) {
  return new Style({
    image: new CircleStyle({
      radius: 12,
      fill: new Fill({ color: '#06232d' }),
      stroke: new Stroke({ color: '#437c8d', width: 1 }),
    }),
    text: new Text({
      text: name,
      font: '14px Arial, sans-serif', // Font size and family,
      fill: new Fill({ color: 'white' }),
      placement: 'point',
      textAlign: 'center',
      textBaseline: 'middle',
    }),
  });
}
